import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const articleCards = [
  {
    key: 'article0',
    link: '/artykul/kakobuy-spreadsheet-poradnik',
    isInternal: true,
    img: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20desk%20with%20open%20laptop%20showing%20a%20modern%20spreadsheet%20interface%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20soft%20natural%20daylight%20through%20a%20window%2C%20Scandinavian%20aesthetic%2C%20organized%20desk%20with%20a%20small%20plant%20and%20coffee%20cup%2C%20editorial%20photography%20with%20gentle%20shadows%2C%20professional%20yet%20inviting%20atmosphere%2C%20no%20text%2C%20airy%20composition&width=500&height=350&seq=article-card-00&orientation=landscape',
  },
  {
    key: 'article1',
    link: '/artykul/kakobuy-bezpieczenstwo',
    isInternal: true,
    img: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20shield%20icon%20on%20warm%20cream%20background%20with%20soft%20natural%20lighting%2C%20security%20and%20safety%20concept%20product%20photography%2C%20clean%20Scandinavian%20aesthetic%2C%20padlock%20next%20to%20a%20smartphone%20on%20light%20sand%20textured%20surface%2C%20gentle%20shadows%2C%20no%20text%2C%20peaceful%20atmosphere&width=500&height=350&seq=article-card-01&orientation=landscape',
  },
  {
    key: 'article2',
    link: '/artykul/kakobuy-sneakers',
    isInternal: true,
    img: 'https://readdy.ai/api/search-image?query=Pair%20of%20trendy%20neutral%20toned%20sneakers%20on%20minimalist%20cream%20pedestal%20with%20soft%20natural%20daylight%2C%20fashion%20editorial%20product%20photography%2C%20clean%20Scandinavian%20surroundings%2C%20warm%20beige%20and%20sand%20palette%2C%20subtle%20shadows%2C%20no%20text%20no%20logos%2C%20elegant%20composition&width=500&height=350&seq=article-card-02&orientation=landscape',
  },
  {
    key: 'article3',
    link: '/artykul/kakobuy-dla-poczatkujacych',
    isInternal: true,
    img: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20minimalist%20illustrations%20and%20a%20warm%20coffee%20cup%20on%20cream%20desk%2C%20soft%20natural%20daylight%2C%20beginner%20guide%20concept%2C%20clean%20Scandinavian%20workspace%2C%20light%20beige%20and%20sand%20tones%2C%20relaxed%20learning%20atmosphere%2C%20no%20text%2C%20editorial%20photography&width=500&height=350&seq=article-card-03&orientation=landscape',
  },
  {
    key: 'article4',
    link: '/artykul/kakobuy-streetwear',
    isInternal: true,
    img: 'https://readdy.ai/api/search-image?query=Stylish%20streetwear%20outfit%20flat%20lay%20on%20warm%20cream%20concrete%20texture%2C%20oversized%20neutral%20toned%20hoodie%20and%20cargo%20pants%2C%20minimalist%20urban%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20modern%20aesthetic&width=500&height=350&seq=article-card-04&orientation=landscape',
  },
  {
    key: 'article5',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    isInternal: false,
    img: 'https://readdy.ai/api/search-image?query=Collection%20of%20diverse%20stylish%20shoes%20in%20neutral%20tones%20on%20warm%20sand%20surface%2C%20minimalist%20footwear%20product%20display%2C%20sneakers%20loafers%20and%20boots%20elegantly%20arranged%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20photography%2C%20no%20text%20no%20logos%2C%20serene%20palette&width=500&height=350&seq=article-card-05&orientation=landscape',
  },
  {
    key: 'article6',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    isInternal: false,
    img: 'https://readdy.ai/api/search-image?query=Beautifully%20folded%20stack%20of%20neutral%20toned%20clothing%20on%20cream%20linen%20surface%2C%20minimalist%20fashion%20display%2C%20t-shirts%20and%20lightweight%20fabrics%20neatly%20organized%2C%20soft%20warm%20natural%20lighting%2C%20clean%20Scandinavian%20aesthetic%2C%20no%20text%20no%20logos%2C%20peaceful%20composition&width=500&height=350&seq=article-card-06&orientation=landscape',
  },
  {
    key: 'article7',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20comparison%20setup%20with%20two%20identical%20products%20side%20by%20side%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20versus%20concept%2C%20elegant%20composition%2C%20no%20text%20no%20logos%2C%20Scandinavian%20minimalism&width=500&height=350&seq=article-card-07&orientation=landscape',
  },
  {
    key: 'article8',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
    img: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20minimalist%20product%20display%20on%20warm%20cream%20background%2C%20discovery%20and%20finding%20deals%20concept%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20photography%2C%20small%20elegant%20accessories%20scattered%2C%20no%20text%20no%20logos%2C%20serene%20atmosphere&width=500&height=350&seq=article-card-08&orientation=landscape',
  },
  {
    key: 'article9',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    isInternal: false,
    img: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20accessories%20flat%20lay%20on%20warm%20sand%20textured%20surface%2C%20minimalist%20bag%20belt%20and%20wallet%20arrangement%2C%20soft%20natural%20lighting%20highlighting%20leather%20grain%2C%20clean%20product%20photography%2C%20no%20text%20no%20logos%2C%20sophisticated%20neutral%20aesthetic&width=500&height=350&seq=article-card-09&orientation=landscape',
  },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="o-czym" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('about.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            {t('about.intro')}
          </p>
        </div>

        <div className="overflow-x-auto -mx-4 px-4">
          <table className="w-full min-w-[600px] border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t('about.tableMethod')}</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t('about.tableAdvantages')}</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t('about.tableDisadvantages')}</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t('about.tableFor')}</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/60 hover:bg-background-50/50 transition-colors">
                <td className="py-3 px-4 text-sm font-medium text-foreground-700">{t('about.method1')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method1Adv')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method1Dis')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method1For')}</td>
              </tr>
              <tr className="border-b border-background-200/60 bg-primary-50/30">
                <td className="py-3 px-4 text-sm font-semibold text-primary-600">{t('about.method2')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method2Adv')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method2Dis')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method2For')}</td>
              </tr>
              <tr className="hover:bg-background-50/50 transition-colors">
                <td className="py-3 px-4 text-sm font-medium text-foreground-700">{t('about.method3')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method3Adv')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method3Dis')}</td>
                <td className="py-3 px-4 text-sm text-foreground-600">{t('about.method3For')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export function BenefitsSection() {
  const { t } = useTranslation();

  const benefits = [
    { icon: 'ri-search-eye-line', title: 'benefit1Title', desc: 'benefit1Desc' },
    { icon: 'ri-team-line', title: 'benefit2Title', desc: 'benefit2Desc' },
    { icon: 'ri-scales-3-line', title: 'benefit3Title', desc: 'benefit3Desc' },
    { icon: 'ri-shield-check-line', title: 'benefit4Title', desc: 'benefit4Desc' },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('benefits.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('benefits.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="group p-6 md:p-7 bg-background-100 rounded-lg border border-background-200/60 hover:border-accent-200 transition-all duration-200"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${b.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {t(`benefits.${b.title}`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`benefits.${b.desc}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SafetySection() {
  const { t } = useTranslation();

  const items = [
    { problem: 'safety.problem1', solution: 'safety.solution1' },
    { problem: 'safety.problem2', solution: 'safety.solution2' },
    { problem: 'safety.problem3', solution: 'safety.solution3' },
    { problem: 'safety.problem4', solution: 'safety.solution4' },
  ];

  return (
    <section id="bezpieczenstwo" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('safety.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('safety.subtitle')}
          </p>
        </div>

        <div className="overflow-x-auto -mx-4 px-4">
          <table className="w-full min-w-[500px] border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800 w-1/3">{t('safety.problemTitle')}</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800">{t('safety.solutionTitle')}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i} className="border-b border-background-200/60 hover:bg-background-50/50 transition-colors">
                  <td className="py-3 px-4 text-sm text-foreground-700 font-medium">{t(item.problem)}</td>
                  <td className="py-3 px-4 text-sm text-foreground-600">{t(item.solution)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section id="poradniki" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('article.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('article.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {articleCards.map((card) => {
            const articleContent = (
              <div className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer h-full flex flex-col">
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={card.img}
                    alt={t(`article.${card.key}Title`)}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">
                    {t(`article.${card.key}Title`)}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                    {t(`article.${card.key}Desc`)}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {t('article.readMore')}
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </span>
                </div>
              </div>
            );

            if (card.isInternal) {
              return (
                <Link key={card.key} to={card.link} className="block h-full">
                  {articleContent}
                </Link>
              );
            }
            return (
              <a
                key={card.key}
                href={card.link}
                target="_blank"
                rel="noopener nofollow"
                className="block h-full"
              >
                {articleContent}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}